import { tavusPersonaStore } from 'entities/tavus/persona';
import { FC } from 'react';
import { BiX } from 'react-icons/bi';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { GoArrowLeft } from 'react-icons/go';
import { TbLayoutSidebarLeftCollapseFilled } from 'react-icons/tb';
import { Link, useLocation } from 'react-router-dom';
import { CREATE_PERSONA_ROUTE, MAIN_ROUTE } from 'shared/model';
import { FilledButton, Loader } from 'shared/ui';

interface IProps {
  isDisabled: boolean;
  isPersonaCreating: boolean;
}
export const TopBar: FC<IProps> = ({ isDisabled, isPersonaCreating }) => {
  const { setSideBarOpened, sideBarOpened } = tavusPersonaStore((state) => ({
    setSideBarOpened: state.setSideBarOpened,
    sideBarOpened: state.sideBarOpened
  }));
  const { pathname } = useLocation();
  const topBarTitle = pathname.includes(CREATE_PERSONA_ROUTE)
    ? 'Create'
    : 'Edit';

  return (
    <div className="lg:ag-col-span-2 ag-h-14 lg:ag-h-16 bg-neutral-white ag-border-b ag-border-neutral-200 ag-font-semibold ag-text-neutral-600 ag-flex ag-flex-row-reverse lg:ag-flex-row ag-justify-between ag-items-center ag-py-4 lg:ag-py-3 ag-px-4 lg:ag-px-6 ag-bg-white">
      <Link
        to={MAIN_ROUTE}
        className="ag-items-center ag-gap-2 ag-hidden lg:ag-flex ag-text-gray-600"
      >
        <GoArrowLeft size={24} />
        Back to agents
      </Link>
      <FilledButton
        className="ag-h-full ag-px-6 ag-hidden lg:ag-flex disabled:ag-bg-primary-600 disabled:ag-opacity-20 ag-w-36"
        disabled={isDisabled}
        type="submit"
      >
        {isPersonaCreating ? <Loader isButton /> : 'Save changes'}
      </FilledButton>

      <button
        type="button"
        onClick={() => setSideBarOpened(!sideBarOpened)}
        className={`ag-flex lg:ag-hidden ag-text-gray-600 ag-duration-200`}
      >
        {sideBarOpened ? (
          <BiX size={24} />
        ) : (
          <TbLayoutSidebarLeftCollapseFilled size={24} />
        )}
      </button>
      <h1 className="ag-font-semibold lg:ag-hidden">
        {topBarTitle} Video Agent
      </h1>
      <Link
        to={MAIN_ROUTE}
        className="ag-p-1 lg:ag-hidden ag-flex flex-row ag-items-center ag-gap-2"
      >
        <GoArrowLeft size={24} />
        <span className="ag-hidden sm:ag-block">Back To agents</span>
      </Link>
    </div>
  );
};
